import {
  useCanUseUndoStack,
  useWriteContext,
} from '@/features/remotion-editor/editor/utils/use-context';
import React, { useCallback } from 'react';
import { Undo } from '@crabs-ai/web-icons';
import { ToolButton } from '@crabs-ai/ds-react';
import { useTranslations } from 'next-intl';

export default function EditorHeaderUndoButton() {
  const t = useTranslations();
  const { undo } = useWriteContext();
  const { canUndo } = useCanUseUndoStack();

  const handleUndo = useCallback(() => {
    undo();
  }, [undo]);

  return (
    <ToolButton
      size="sm"
      isTransparent={false}
      state={canUndo ? 'default' : 'disabled'}
      isShowTooltip={true}
      onClick={handleUndo}
      tooltipNode={t('Editor.header.undo')}
      tooltipSubNode="[⌘/Ctrl + Z]"
    >
      <Undo />
    </ToolButton>
  );
}
